import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import _ from 'lodash';

//utils
import queries from '../../utils/queries'

import HomeMigrar1 from './homemigrar1';
import HomeMigrar2 from './homemigrar2';

// function getNumDiasMes(mesDias, agnoDias){
//   /*
//       Los meses 1,3,5,7,8,10,12 siempre tienen 31 días
//       Los meses 4,6,9,11 siempre tienen 30 días
//       El mes de febrero dependiendo del año puede tener 28 o 29 días
//   */
//   let mes = parseInt(mesDias, 10)
//   let agno = parseInt(agnoDias, 10)

//   if( (mes === 1) || (mes === 3) || (mes === 5) || (mes === 7) || (mes === 8) || (mes === 10) || (mes === 12) ) 
//     return 31;
//   else if( (mes === 4) || (mes === 6) || (mes === 9) || (mes === 11) ) 
//     return 30;
//   else if( mes === 2 )
//   {
//       if((agno % 4 === 0) && ((agno % 100 !== 0) || (agno % 400 === 0)))
//         return 29;
//       else
//         return 28;
//   }   
// }

let argsBuscarMCNeg = {tipoqry: `[{$match: {tipo: 'X'}},{$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}}]`}

class HomeMigrar extends React.Component{
  state={showMigrar: true}

  estadosFalse = () => {
    this.setState({argsAdd: {}})
    this.setState({errorAdd: []})

    Object.values(this.state).forEach((estado, i) => {
      if(estado===true){
        // console.log(Object.getOwnPropertyNames(this.state)[i])
        // if(typeof estado === "boolean"){
        this.setState({ [Object.getOwnPropertyNames(this.state)[i]]: false })
      }
    })
  }

  ordenarArrayAsc = (array, campo) => {
    array.sort(function (a, b) {
       return a[campo] > b[campo];
    });
  }

  crudBD = async (operacionCRUD, args, i)=>{
    //ACTUALIZAR BD
    console.log("CRUD")
          if(args.ctrlCampo === 'CRUD'){
    console.log(i)
            const {data} = await operacionCRUD({
              variables: args
            });
      
    //Se utiliza para traer el _id del documento creado
            if(args.ctrl_id === 'SI_ID'){
              if(Object.values(data)[0]._id){
                return Object.values(data)[0]._id
              }else{
                return 0
              }
            }
          }else{
              if(args.ctrlCampo === "MANY"){
                await operacionCRUD({
                  variables: args
                });
              }
          }
  }
    
        updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
      //ENVIO PARA ACTUALIZAR BD
          let codigo = 0
          if(argsCrud[0].ctrl_id === 'SI_ID'){
            codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
          }else{
            await this.crudBD(crudColecc[0], argsCrud[0], 0)
          }
          if(codigo!==0){
            for(let i=1; i<totDocCRUD; i++){
              argsCrud[i]._id = codigo
            }
          }
console.log("inicio")
          for(let i=1; i<totDocCRUD; i++){
            await this.crudBD(crudColecc[i], argsCrud[i], i)
          }
console.log("final")
        }
    
  showMigrar = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showMigrar: true})
  }

//INICIA MIGRACION
handleMigBarr = async ()=>{
  let args = {}
  const elemMigrars = await this.props.allMigrarBarrio.allMigrarBarrio
  
  // elemMigrars.forEach(async (elemMigrar, i) => {
  for(let i=0; i<elemMigrars.length; i++){
    let elemMigrar = elemMigrars[i]
    args = {}
    args['_id'] = elemMigrar.codDpto
    args['codigoCiudad'] = elemMigrar.codCiudad
    args['codigoZona'] = elemMigrar.codZonas
    args['nombreZona'] = elemMigrar.zona
    args['codigoBarrio'] = elemMigrar.codigoBarrio
    args['nombreBarrio'] = elemMigrar.nombrearea
    args['descrRecursoT'] = elemMigrar.descrRecursoT
    args['numeroDocumT'] = elemMigrar.numeroDocumT
    args['codigoTipoDocT'] = elemMigrar.codigoTipoDocT
    args['descrRecursoR'] = elemMigrar.descrRecursoR
    args['numeroDocumR'] = elemMigrar.numeroDocumR
    args['codigoTipoDocR'] = elemMigrar.codigoTipoDocR
console.log(i)
    let editar = ""
    if(i===0){
      editar = "CrearBarrio1"
    }else{
      editar = "CrearBarrio2"
    }
    const errors = [];

// //Validar si el codigo o el nombre del barrio ya existe en la ciudad
//     var editar = "CrearBarrio2"
//     const elemento3 = this.props.allDirmayor.allDirmayor
//     elemento3.forEach((elemento, _id) => {
//       if(elemento.ciudades.length>0 && elemento._id===args._id){
//         elemento.ciudades.forEach((elemento1, i) => {
//           if(args.codigoCiudad===elemento1.codigoCiudad){
//             elemento1.zonas.forEach((elemento2, i) => {
//               if(args.codigoZona===elemento2.codigoZona){
//                 elemento2.barrios.forEach((elemento3, i) => {
//                   if(!elemento3.codigoBarrio){
//                     editar = "CrearBarrio1"
//                     // console.log("NO tiene barrios")
//                   }else{
//                     if(args.codigoBarrio===elemento3.codigoBarrio){
//                       errors.push({path: 'codigoBarrio', message: "El código del barrio ya existe en la ciudad"});
//                     }
//                     if(args.nombreBarrio===elemento3.nombreBarrio){
//                       errors.push({path: 'nombreBarrio', message: "El nombre del barrio ya existe en la ciudad"});
//                     }
//                   }
//                 })
//               }else{
//                 elemento2.barrios.forEach((elemento3, i) => {
//                   if(elemento3.codigoBarrio){
//                     if(args.codigoBarrio===elemento3.codigoBarrio){
//                       errors.push({path: 'codigoBarrio', message: "El código del barrio ya existe en la ciudad"});
//                     }
//                     if(args.nombreBarrio===elemento3.nombreBarrio){
//                       errors.push({path: 'nombreBarrio', message: "El nombre del barrio ya existe en la ciudad"});
//                     }
//                   }
//                 })
//               }
//             })
//           }
//         })
//       }
//     })
console.log(args)
    if(errors.length===0){
      const fechaHoy = new Date()
      const argsUpd = {
        "_id": args._id,
        "tipoAct": editar,
        "codigoCiudad": args.codigoCiudad,
        "codigoZona": args.codigoZona,
        "nombreZona": args.nombreZona,
        "codigoBarrio": args.codigoBarrio,
        "nombreBarrio": args.nombreBarrio,
        "descrRecursoT": args.descrRecursoT,
        "numeroDocumT": args.numeroDocumT,
        "codigoTipoDocT": args.codigoTipoDocT,
        "descrRecursoR": args.descrRecursoR,
        "numeroDocumR": args.numeroDocumR,
        "codigoTipoDocR": args.codigoTipoDocR,
        "fechaCreateBarr": fechaHoy,
        "usuarioCreateBarr": sessionStorage.getItem('userLogin')
      }
      console.log(argsUpd)
      const response = await this.props.editDptoUpdCiu({
        variables: argsUpd
      });
      const {errors, success} = response.data.editDptoUpdCiu;
      if (!success){
        console.log(errors)
      }
    }else{
      console.log(errors)
    }
  }
  // })
}

handleMigServ = async ()=>{
  let args = {}

  const elemMigrars = this.props.allMigrarServicio.allMigrarServicio
  const elemSearch = this.props.allSubclasesServ.allSubclasesServ
  elemMigrars.forEach(async (elemMigrar, i) => {
    const indexSearch = elemSearch.findIndex( subclase => subclase.descrSubclaseServ===elemMigrar.subclase )
    if(indexSearch!==-1){
      args = {}
      args['_idClaseServ'] = elemMigrar.idClaseServ
      args['codigoClaseServ'] = elemMigrar.codigoClaseServ
      args['descrClaseServ'] = elemMigrar.descrClaseServ
      args['codigoServicio'] = elemMigrar.codServicio
      args['nombreResumido'] = elemMigrar.DescResServicio
      args['descripcionServicio'] = elemMigrar.DescServicio
      args['conceptoEnFra'] = elemMigrar.conceptoFra
      args['paraProcMasDX'] = "Si"
      args['consecEnFra'] = elemMigrar.consecutivo
      args['_idSubclaseServ'] = elemSearch[indexSearch]._id
      args['codigoSubclaseServ'] = elemSearch[indexSearch].codigoSubclaseServ
      args['descrSubclaseServ'] = elemMigrar.subclase

    console.log(args)
      const response = await this.props.createServicio({
        variables: args
      });
      const {errors, success} = response.data.createServicio;
      if (!success){
        console.log(errors)
      }
    }
  })
}

handleMigTar = async ()=>{
  let args = {}

  const elemMigrars = this.props.allMigrarTarifa.allMigrarTarifa
  const elemSearch = this.props.allServicios.allServicios
console.log(elemMigrars)
//AGREGAR SERVICIOS A LA TARIFA
  elemMigrars.forEach(async (elemMigrar, i) => {
    const indexSearch = elemSearch.findIndex( servicio => servicio.descripcionServicio===elemMigrar.DescServicio )
    if(indexSearch!==-1){
      args = {}

      if(elemMigrar.ParaTarifa===2||elemMigrar.ParaTarifa===0){
//TARIFA SIN IVA
        args['codigoClaseServ'] = elemSearch[indexSearch].subclaseserv.claseserv.codigoClaseServ
        args['codigoServicio'] = elemSearch[indexSearch].codigoServicio
        args['codigoSubclaseServ'] = elemSearch[indexSearch].subclaseserv.codigoSubclaseServ
        args['descrClaseServ'] = elemSearch[indexSearch].subclaseserv.claseserv.descrClaseServ
        args['descrSubclaseServ'] = elemSearch[indexSearch].subclaseserv.descrSubclaseServ
        args['descripcionServicio'] = elemSearch[indexSearch].descripcionServicio
        args['nombreResumido'] = elemSearch[indexSearch].nombreResumido
        args['tipoAct'] = "EditarTarSer"
        args['_id'] = "5bdb2539b578b22d4889428d"
        args['_idClaseServ'] = elemSearch[indexSearch].subclaseserv.claseserv._id
        args['_idSubclaseServ'] = elemSearch[indexSearch].subclaseserv._id

        console.log(args)
        const response = await this.props.editTarifaUpdServ({
          variables: args
        });
        const {errors, success} = response.data.editTarifaUpdServ;
        if (!success){
          console.log(errors)
        }
      }

      args = {}
      if(elemMigrar.ParaTarifa===2||elemMigrar.ParaTarifa===1){
//TARIFA CON IVA
        args['codigoClaseServ'] = elemSearch[indexSearch].subclaseserv.claseserv.codigoClaseServ
        args['codigoServicio'] = elemSearch[indexSearch].codigoServicio
        args['codigoSubclaseServ'] = elemSearch[indexSearch].subclaseserv.codigoSubclaseServ
        args['descrClaseServ'] = elemSearch[indexSearch].subclaseserv.claseserv.descrClaseServ
        args['descrSubclaseServ'] = elemSearch[indexSearch].subclaseserv.descrSubclaseServ
        args['descripcionServicio'] = elemSearch[indexSearch].descripcionServicio
        args['nombreResumido'] = elemSearch[indexSearch].nombreResumido
        args['tipoAct'] = "EditarTarSer"
        args['_id'] = "5bdb2527b578b22d4889428c"
        args['_idClaseServ'] = elemSearch[indexSearch].subclaseserv.claseserv._id
        args['_idSubclaseServ'] = elemSearch[indexSearch].subclaseserv._id

        console.log(args)
        const response = await this.props.editTarifaUpdServ({
          variables: args
        });
        const {errors, success} = response.data.editTarifaUpdServ;
        if (!success){
          console.log(errors)
        }
      }
    }
  })

//AGREGAR RANGOS Y VALORES A LOS SERVICIOS DE LA TARIFA
elemMigrars.forEach(async (elemMigrar, i) => {
  const indexSearch = elemSearch.findIndex( servicio => servicio.descripcionServicio===elemMigrar.DescServicio )
  if(indexSearch!==-1){
    args = {}

    if(elemMigrar.ParaTarifa===2||elemMigrar.ParaTarifa===0){
//TARIFA SIN IVA
      args['codigoServicio'] = elemSearch[indexSearch].codigoServicio
      args['rango1NumServValorFin'] = "1"
      args['rango1NumServValorIni'] = "1"
      args['rango1Valor'] = elemMigrar.Valor
      args['rango2NumServValorFin'] = null
      args['rango2NumServValorIni'] = null
      args['rango2Valor'] = null
      args['rango3NumServValorFin'] = null
      args['rango3NumServValorIni'] = null
      args['rango3Valor'] = null
      args['tipoAct'] = "EditarTarRangos"
      args['_id'] = "5bdb2539b578b22d4889428d"

      console.log(args)
      const response = await this.props.editTarifaUpdServ({
        variables: args
      });
      const {errors, success} = response.data.editTarifaUpdServ;
      if (!success){
        console.log(errors)
      }
    }

    args = {}
    if(elemMigrar.ParaTarifa===2||elemMigrar.ParaTarifa===1){
//TARIFA CON IVA
      args['codigoServicio'] = elemSearch[indexSearch].codigoServicio
      args['rango1NumServValorFin'] = "1"
      args['rango1NumServValorIni'] = "1"
      args['rango1Valor'] = elemMigrar.Valor
      args['rango2NumServValorFin'] = null
      args['rango2NumServValorIni'] = null
      args['rango2Valor'] = null
      args['rango3NumServValorFin'] = null
      args['rango3NumServValorIni'] = null
      args['rango3Valor'] = null
      args['tipoAct'] = "EditarTarRangos"
      args['_id'] = "5bdb2527b578b22d4889428c"

      console.log(args)
      const response = await this.props.editTarifaUpdServ({
        variables: args
      });
      const {errors, success} = response.data.editTarifaUpdServ;
      if (!success){
        console.log(errors)
      }
    }
  }
})

//AGREGAR IMPUESTOS A LOS SERVICIOS DE LA TARIFA
elemMigrars.forEach(async (elemMigrar, i) => {
  const indexSearch = elemSearch.findIndex( servicio => servicio.descripcionServicio===elemMigrar.DescServicio )
  if(indexSearch!==-1){
    args = {}

    if((elemMigrar.ParaTarifa===2||elemMigrar.ParaTarifa===0)&&elemMigrar.IVA!==0){
//TARIFA SIN IVA
      args['codigoImpto'] = "IVA"
      args['codigoServicio'] = elemSearch[indexSearch].codigoServicio
      args['descrImpto'] = "IVA"
      args['porcImpto'] = 19
      args['tipoAct'] = "CrearImpto"
      args['_id'] = "5bdb2539b578b22d4889428d"
      args['_idImpto'] = "5bda382fb578b22d48894288"

      console.log(args)
      const response = await this.props.editTarifaUpdServ({
        variables: args
      });
      const {errors, success} = response.data.editTarifaUpdServ;
      if (!success){
        console.log(errors)
      }
    }

    args = {}
    if((elemMigrar.ParaTarifa===2||elemMigrar.ParaTarifa===1)&&elemMigrar.IVA!==0){
//TARIFA CON IVA
      args['codigoImpto'] = "IVA"
      args['codigoServicio'] = elemSearch[indexSearch].codigoServicio
      args['descrImpto'] = "IVA"
      args['porcImpto'] = 19
      args['tipoAct'] = "CrearImpto"
      args['_id'] = "5bdb2527b578b22d4889428c"
      args['_idImpto'] = "5bda382fb578b22d48894288"

      console.log(args)
      const response = await this.props.editTarifaUpdServ({
        variables: args
      });
      const {errors, success} = response.data.editTarifaUpdServ;
      if (!success){
        console.log(errors)
      }
    }
  }
})

//ELIMINAR IMPUESTOS CON _id  null
elemMigrars.forEach(async (elemMigrar, i) => {
  const indexSearch = elemSearch.findIndex( servicio => servicio.descripcionServicio===elemMigrar.DescServicio )
  if(indexSearch!==-1){
    args = {}

    if((elemMigrar.ParaTarifa===2||elemMigrar.ParaTarifa===0)&&elemMigrar.IVA!==0){
//TARIFA SIN IVA
      args['codigoServicio'] = elemSearch[indexSearch].codigoServicio
      args['tipoAct'] = "EliminarImpto"
      args['_id'] = "5bdb2539b578b22d4889428d"
      args['_idImpto'] = null

      console.log(args)
      const response = await this.props.editTarifaUpdServ({
        variables: args
      });
      const {errors, success} = response.data.editTarifaUpdServ;
      if (!success){
        console.log(errors)
      }
    }

    args = {}
    if((elemMigrar.ParaTarifa===2||elemMigrar.ParaTarifa===1)&&elemMigrar.IVA!==0){
//TARIFA CON IVA
      args['codigoServicio'] = elemSearch[indexSearch].codigoServicio
      args['tipoAct'] = "EliminarImpto"
      args['_id'] = "5bdb2527b578b22d4889428c"
      args['_idImpto'] = null

      console.log(args)
      const response = await this.props.editTarifaUpdServ({
        variables: args
      });
      const {errors, success} = response.data.editTarifaUpdServ;
      if (!success){
        console.log(errors)
      }
    }
  }
})
}

handleMigCli = ()=>{
  let argsAdd = {}
  let cuentaMigrados = 0
  let creaColecc = []
  // let actColecc = []

  var elemMigrars = this.props.allMigrarCliente.allMigrarCliente
  const elemMigrars1 = this.props.allCliTodos.allCliTodos
  const elemSearch1 = this.props.allTiposDoc.allTiposDoc
  const elemSearch2 = this.props.allGruposAfin.allGruposAfin
  const elemSearch3 = this.props.allTiposCliente.allTiposCliente
  var indexSearch = -1, indexSearch1 = -1, indexSearch2 = -1, indexSearch3 = -1
  console.log(this.props.allMigrarCliente.allMigrarCliente)
  console.log(elemMigrars)
  if(!elemMigrars){
    console.log("elemMigrars vacio")
    elemMigrars = []
  }else{
    console.log("elemMigrars ok")
  }
  // elemMigrars.forEach((elemMigrar, i) => {
  for(let i=0; i<elemMigrars.length; i++){
    let elemMigrar = elemMigrars[i]
    // console.log(i)
    if(cuentaMigrados<64000){
      indexSearch = elemMigrars1.findIndex( cliente => cliente.contrato===elemMigrar.contrato )
      if(indexSearch===-1){
        cuentaMigrados += 1

        indexSearch1 = elemSearch1.findIndex( tipodoc => tipodoc.codigoTipoDoc===elemMigrar.codigoTipoDoc )
        indexSearch2 = elemSearch2.findIndex( grupoafin => grupoafin.codigoGrupoAfin===elemMigrar.codigoGrupoAfin )
        indexSearch3 = elemSearch3.findIndex( tipocliente => tipocliente.codigoTipoCliente===elemMigrar.codigoTipoCliente )

        // console.log(indexSearch1, elemMigrar.codigoTipoDoc)
        // console.log(indexSearch2, elemMigrar.codigoGrupoAfin)
        // console.log(indexSearch3, elemMigrar.codigoTipoCliente)
      }
    }
    // console.log(indexSearch)
    // console.log(elemMigrar.contrato, indexSearch1, indexSearch2, indexSearch3, indexSearch, cuentaMigrados)
    if(indexSearch1!==-1&&indexSearch2!==-1&&indexSearch3!==-1&&
        indexSearch===-1&&cuentaMigrados<64000){
      // console.log(cuentaMigrados, elemMigrar.contrato)

      // //optimizar con web worker => ESTUDIARLO
      // var worker = new Worker('respond.js');
      // worker.addEventListener('message', recibido, false);
      // function recibido(e) {
      //   console.log(e.data);
      // }
      // worker.postMessage('Hello World');
      // worker.terminate();

      //CREAR LOS CLIENTES
      // creaColecc = []

      argsAdd = {}
      let saldoCl = 0
      // if(elemMigrar.contratosnet===""||elemMigrar.contratosnet===null){
      //   saldoCl = elemMigrar.saldoPendiente
      // }else{
        saldoCl = elemMigrar.saldoPendiente
      // }
      argsAdd['nombreCliente'] = elemMigrar.nombreCliente?elemMigrar.nombreCliente:elemMigrar.apellidoCliente
      argsAdd['apellidoCliente'] = elemMigrar.apellidoCliente?elemMigrar.apellidoCliente:elemMigrar.nombreCliente
      argsAdd['contrato'] = elemMigrar.contrato
      argsAdd['estadoCliente'] = elemMigrar.estadoCliente
      argsAdd['saldoPendiente'] = saldoCl
      argsAdd['descrEstrato'] = elemMigrar.descrEstrato
      argsAdd['cicloFact'] = "Pasto Internet"
      argsAdd['numeroOdeDX'] = 0
      argsAdd['eMail'] = elemMigrar.eMail
      argsAdd['referencia1'] = elemMigrar.referencia1
      argsAdd['telefonoRef1'] = elemMigrar.telefonoRef1
      argsAdd['referencia2'] = elemMigrar.referencia2
      argsAdd['telefonoRef2'] = elemMigrar.telefonoRef2
      argsAdd['numeroDoc'] = elemMigrar.numeroDoc
      argsAdd['observaciones'] = elemMigrar.observaciones
      argsAdd['codigoMarquilla'] = elemMigrar.codigoMarquilla
      argsAdd['sexoCliente'] = "Masculino"
      argsAdd['telefono1'] = elemMigrar.telefono1
      argsAdd['telefono2'] = elemMigrar.telefono2
      argsAdd['telefono3'] = elemMigrar.telefono3

      let fechaafiliacion = null
      let fechadesconexionretiro = null
      let fechareconexiion = null
      let fecultimopago = null

      argsAdd['fechaPrimeraActivacion'] = fechaafiliacion
      argsAdd['fechaCreacionSistema'] = "2023-11-24"
      argsAdd['fechaUltDX'] = fechadesconexionretiro
      argsAdd['fecgaUltRX'] = fechareconexiion
      argsAdd['fechaUltPago'] = fecultimopago
      argsAdd['valorUltPago'] = 0

      argsAdd['tipodoc'] = {_id: elemSearch1[indexSearch1]._id,
        codigoTipoDoc: elemMigrar.codigoTipoDoc, descrTipoDoc: elemSearch1[indexSearch1].descrTipoDoc}
      argsAdd['tipocl'] = {
        codigoTipoCliente: elemMigrar.codigoTipoCliente, descrTipoCliente: elemSearch3[indexSearch3].descrTipoCliente}
      argsAdd['grupoaf'] = {_id: elemSearch2[indexSearch2]._id,
        codigoGrupoAfin: elemMigrar.codigoGrupoAfin, descrGrupoAfin: elemSearch2[indexSearch2].descrGrupoAfin}

      argsAdd['usuarioCreate'] = sessionStorage.getItem('userLogin')
      argsAdd['usuarioUltView'] = sessionStorage.getItem('userLogin')

      creaColecc.push(argsAdd)
      // console.log(argsAdd)

      //Para procesar cada 2000 de forma secuencial
      // console.log(creaColecc.length)
      if(creaColecc.length>=100){
        // console.log(creaColecc.length)
        let creaColecc1 = []
        creaColecc1.push({cliente: creaColecc})
        
        // console.log(creaColecc1)
        // console.log(actCliMany1)
        
        //Crear el cliente y los movim
        let numDocCRUD = 0
        let totDocCRUD = 1
        let argsCrud = []
        let crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.createClienteMany)
        }
        
        argsCrud[numDocCRUD] = creaColecc1[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.createClienteMany
        
        // console.log(argsCrud)
        // console.log(totDocCRUD)
        this.updColecc(crudColecc, argsCrud, totDocCRUD)


        // let creaColecc1 = []
        // creaColecc1.push({cliente: creaColecc})
        
        // //Crear el cliente y los movim
        // let numDocCRUD = 0
        // let totDocCRUD = 1
        // let argsCrud = []
        // let crudColecc = []
        // for(let iii=0; iii<totDocCRUD; iii++){
        // argsCrud.push({ctrlCampo: 'NO_CRUD'})
        // }
        // for(let iii=0; iii<totDocCRUD; iii++){
        // crudColecc.push(this.props.createClienteMany)
        // }
        
        // argsCrud[numDocCRUD] = creaColecc1[0]
        // argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
        // argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        // crudColecc[numDocCRUD] = this.props.createClienteMany
        
        // console.log(argsCrud)
        // console.log(totDocCRUD)
        // this.updColecc(crudColecc, argsCrud, totDocCRUD)

        creaColecc = []
      }
    }else{
      console.log(indexSearch1, indexSearch2, indexSearch3)

      console.log('contratos que ya existian en foroptic y NO se migraron: ', cuentaMigrados, elemMigrar.contrato)
    }
  }
  // })

  //para procesar los pendientes
  if(creaColecc.length>0){
    console.log(creaColecc.length)

    let creaColecc1 = []
    creaColecc1.push({cliente: creaColecc})

    console.log(creaColecc1)
    // console.log(actCliMany1)

    //Crear el cliente y los movim
    let numDocCRUD = 0
    let totDocCRUD = 1
    let argsCrud = []
    let crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      crudColecc.push(this.props.createClienteMany)
    }

    argsCrud[numDocCRUD] = creaColecc1[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.createClienteMany

    console.log(argsCrud)
    console.log(totDocCRUD)
    this.updColecc(crudColecc, argsCrud, totDocCRUD)


  }


  console.log("Listooooooo")
}

handleMigDir = async ()=>{
  let argsAdd = {}
  let cuentaMigrados = 0, movColecc = []

  var elemMigrarsD1 = this.props.allMigrarDirmayor.allMigrarDirmayor
  var elemMigrarsD2 = this.props.allMigrarDireccion.allMigrarDireccion
  const elemMigrarCli = this.props.allCliTodos.allCliTodos
  const elemDirMayor = this.props.allDirmayor.allDirmayor
  // console.log(elemDirMayor)
  const elemMigrarBarr = this.props.allMigrarBarrio.allMigrarBarrio
  // let indexSearch1 = -1, indexSearch2 = -1, indexSearchDM = -1, indexSearchB = -1
  if(!elemMigrarsD1){
    console.log("elemMigrarsD1 vacio")
    elemMigrarsD1 = []
  }else{
    console.log(elemMigrarsD1.length)
  }
  if(!elemMigrarsD2){
    console.log("elemMigrarsD2 vacio")
    elemMigrarsD2 = []
  }else{
    console.log(elemMigrarsD2.length)
  }
  // let cuentaNo = 0
  // elemMigrarCli.forEach(async (elemMigrar, i) => {
  for(let i=0; i<elemMigrarCli.length; i++){
    // La siguiente linea estaba en la linea 720, pero se pasa aqui para evitar error
    // al ejecutar el npm start, verificar que sigue funcionando OK
    let indexSearch1 = -1, indexSearch2 = -1, indexSearchDM = -1, indexSearchB = -1

    let elemMigrar = elemMigrarCli[i]

    let tieneDocum = false

    if(cuentaMigrados<50000){
      indexSearch1 = this.props.allClientes1.allClientes.findIndex( cliente => cliente.contrato===elemMigrar.contrato )
      // console.log(indexSearch1, elemMigrar.contrato)
      if(indexSearch1!==-1){
        if(this.props.allClientes1.allClientes[indexSearch1].dirmayor.codigoDpto){
          tieneDocum = true
        // }else{
        //   cuentaNo += 1
        //   console.log(cuentaNo)
          // console.log(this.props.allClientes1.allClientes[indexSearch1].contrato)
        }
      }
    }
    // cuentaMigrados=60000
    if(cuentaMigrados<50000&&!tieneDocum){
      indexSearch1 = elemMigrarsD1.findIndex( cliente => cliente.contrato===elemMigrar.contrato )
      if(indexSearch1!==-1){
        indexSearch2 = elemMigrarsD2.findIndex( cliente => cliente.contrato===elemMigrar.contrato )
        if(indexSearch2!==-1){
          indexSearchDM = elemDirMayor.findIndex( dirmayor => dirmayor.codigoDpto===elemMigrarsD1[indexSearch1].CODDPTO )
          indexSearchB= elemMigrarBarr.findIndex( barrio => barrio.nombrearea.toUpperCase()===elemMigrarsD1[indexSearch1].nombrearea.toUpperCase() )
        }  
      }
    }
    // if(!tieneDocum){
    // console.log(tieneDocum)
    // console.log(indexSearch1)
    // console.log(indexSearch2)
    // console.log(indexSearchDM)
    // console.log(indexSearchB)
    // }
    if(indexSearch1!==-1&&indexSearch2!==-1&&indexSearchDM!==-1&&indexSearchB!==-1&&cuentaMigrados<50000&&!tieneDocum){
        cuentaMigrados += 1
        console.log(cuentaMigrados)

//ACTUALIZAR DIRECCION A LOS CLIENTES
      // movColecc = []
      argsAdd = {}

      argsAdd['tipoAct'] = "EditarDirmayor"
      argsAdd['_id'] = elemMigrar._id

      argsAdd['dirmayor'] = {codigoDpto: elemMigrarsD1[indexSearch1].CODDPTO,
        descrDpto: elemMigrarsD1[indexSearch1].DPTO,
        ciudades: {codigoCiudad: elemMigrarsD1[indexSearch1].CODCIUDAD,
          nombreCiudad: elemMigrarsD1[indexSearch1].CIUDAD,
          zonas: {codigoZona: elemMigrarsD1[indexSearch1].CODZONAS,
            nombreZona: elemMigrarsD1[indexSearch1].ZONA,
            barrios: {codigoBarrio: elemMigrarBarr[indexSearchB].codigoBarrio,
              nombreBarrio: elemMigrarBarr[indexSearchB].nombrearea,
              descrRecursoT: elemMigrarBarr[indexSearchB].descrRecursoT,
              numeroDocumT: elemMigrarBarr[indexSearchB].numeroDocumT,
              codigoTipoDocT: elemMigrarBarr[indexSearchB].codigoTipoDocT,
              descrRecursoR: elemMigrarBarr[indexSearchB].descrRecursoR,
              numeroDocumR: elemMigrarBarr[indexSearchB].numeroDocumR,
              codigoTipoDocR: elemMigrarBarr[indexSearchB].codigoTipoDocR
          }}}}

      // argsAdd['_idDirmayor'] = elemDirMayor[indexSearchDM]._id
      // argsAdd['codigoDpto'] = elemMigrarsD1[indexSearch1].CODDPTO
      // argsAdd['descrDpto'] = elemMigrarsD1[indexSearch1].DPTO
      // argsAdd['codigoCiudad'] = elemMigrarsD1[indexSearch1].CODCIUDAD
      // argsAdd['nombreCiudad'] = elemMigrarsD1[indexSearch1].CIUDAD
      // argsAdd['codigoZona'] = elemMigrarsD1[indexSearch1].CODZONAS
      // argsAdd['nombreZona'] = elemMigrarsD1[indexSearch1].ZONA
      // argsAdd['codigoBarrio'] = elemMigrarBarr[indexSearchB].codigoBarrio
      // argsAdd['nombreBarrio'] = elemMigrarsD1[indexSearch1].nombrearea

      argsAdd['direccion'] = {descrTipoVia1: elemMigrarsD2[indexSearch2].TipoVia1,
        numeroTipoVia1: elemMigrarsD2[indexSearch2].campo2dir,
        descrTipoVia2: elemMigrarsD2[indexSearch2].TipoVia2,
        numeroTipoVia2: elemMigrarsD2[indexSearch2].campo4dir,
        numeroTipoVia2F: elemMigrarsD2[indexSearch2].campo5dir,
        descrTipoUnd1: elemMigrarsD2[indexSearch2].TipoUnd1?elemMigrarsD2[indexSearch2].TipoUnd1:null,
        numeroTipoUnd1: elemMigrarsD2[indexSearch2].direccioninterna?elemMigrarsD2[indexSearch2].direccioninterna:null,
        descrTipoUnd2: elemMigrarsD2[indexSearch2].TipoUnd2?elemMigrarsD2[indexSearch2].TipoUnd2:null,
        numeroTipoUnd2: (elemMigrarsD2[indexSearch2].Piso||elemMigrarsD2[indexSearch2].direccioninterna1)?
          elemMigrarsD2[indexSearch2].Piso + ' ' + elemMigrarsD2[indexSearch2].direccioninterna1:null,
      }

      // argsAdd['descrTipoVia1'] = elemMigrarsD2[indexSearch2].TipoVia1
      // argsAdd['numeroTipoVia1'] = elemMigrarsD2[indexSearch2].campo2dir
      // argsAdd['descrTipoVia2'] = elemMigrarsD2[indexSearch2].TipoVia2
      // argsAdd['numeroTipoVia2'] = elemMigrarsD2[indexSearch2].campo4dir
      // argsAdd['numeroTipoVia2F'] = elemMigrarsD2[indexSearch2].campo5dir
      // if(elemMigrarsD2[indexSearch2].TipoUnd1){
      //   argsAdd['descrTipoUnd1'] = elemMigrarsD2[indexSearch2].TipoUnd1
      // }
      // if(elemMigrarsD2[indexSearch2].direccioninterna){
      //   argsAdd['numeroTipoUnd1'] = elemMigrarsD2[indexSearch2].direccioninterna
      // }
      // if(elemMigrarsD2[indexSearch2].TipoUnd2){
      //   argsAdd['descrTipoUnd2'] = elemMigrarsD2[indexSearch2].TipoUnd2
      // }
      // if(elemMigrarsD2[indexSearch2].Piso||elemMigrarsD2[indexSearch2].direccioninterna1){
      //   argsAdd['numeroTipoUnd2'] = elemMigrarsD2[indexSearch2].Piso + ' ' + elemMigrarsD2[indexSearch2].direccioninterna1
      // }
      movColecc.push(argsAdd)
      console.log(argsAdd)

// //Para procesar cada 200 de forma secuencial
//       if(movColecc.length>=200){
// //Actualizar dirección
//         let numDocCRUD = 0
//         let totDocCRUD = movColecc.length
//         let argsCrud = []
//         let crudColecc = []
//         for(let iii=0; iii<totDocCRUD; iii++){
//           argsCrud.push({ctrlCampo: 'NO_CRUD'})
//         }
//         for(let iii=0; iii<totDocCRUD; iii++){
//           crudColecc.push(this.props.editClienteUpdDoc)
//         }

//         movColecc.forEach((elemento1, ii) => {
//           argsCrud[numDocCRUD] = elemento1
//           argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
//           argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

//           numDocCRUD += 1
//         })
//         this.updColecc(crudColecc, argsCrud, totDocCRUD)

//         movColecc = []
//       }
    }
  }
  // })

  if(movColecc.length>0){
    let actCliMany1 = []
    actCliMany1.push({cliente: movColecc})

    console.log(movColecc)
  console.log(actCliMany1)
  
  //Actualiza la dir de los clientes
  let numDocCRUD = 0
  let totDocCRUD = 1
  let argsCrud = []
  let crudColecc = []
  for(let iii=0; iii<totDocCRUD; iii++){
    argsCrud.push({ctrlCampo: 'NO_CRUD'})
  }
  for(let iii=0; iii<totDocCRUD; iii++){
    crudColecc.push(this.props.editClienteUpdDocMany)
  }
  
  argsCrud[numDocCRUD] = actCliMany1[0]
  argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
  argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
  crudColecc[numDocCRUD] = this.props.editClienteUpdDocMany
  
  console.log(argsCrud)
  console.log(totDocCRUD)
  this.updColecc(crudColecc, argsCrud, totDocCRUD)
  
}  





// //para procesar los pendientes
//   if(movColecc.length>0){
// //Actualizar dirección
//     let numDocCRUD = 0
//     let totDocCRUD = movColecc.length
//     let argsCrud = []
//     let crudColecc = []
//     for(let iii=0; iii<totDocCRUD; iii++){
//       argsCrud.push({ctrlCampo: 'NO_CRUD'})
//     }
//     for(let iii=0; iii<totDocCRUD; iii++){
//       crudColecc.push(this.props.editClienteUpdDoc)
//     }

//     movColecc.forEach((elemento1, ii) => {
//       argsCrud[numDocCRUD] = elemento1
//       argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
//       argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

//       numDocCRUD += 1
//     })
//     this.updColecc(crudColecc, argsCrud, totDocCRUD)
//   }

  // console.log(cuentaMigrados)
  // console.log(movColecc.length)

  console.log("Listooooooo")
}

handleMigTarCli = ()=>{
  let argsAdd = {}
  // let argsUpd = {}
  let cuentaMigrados = 0
  let creaColecc = []
  // let movColecc = []

  const fechaHoy = new Date()
  let fechaV = (fechaHoy.getFullYear()+1) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
  
  var elemMigrarsTC = this.props.allMigrarTarifaCli.allMigrarTarifaCli
  const elemMigrarCli = this.props.allCliTodos.allCliTodos
  const elemTarifa = this.props.allTarifa.allTarifa
  if(!elemMigrarsTC){
    console.log("elemMigrarsTC vacio")
    elemMigrarsTC = []
  }else{
    console.log(elemMigrarsTC.length)
  }
  // let indexSearch1 = -1
// console.log(elemMigrarCli.length)
  // let cuentaNo = 0

  // elemMigrarCli.forEach((elemMigrar, i) => {
    for(let i=0; i<elemMigrarCli.length; i++){
      let elemMigrar = elemMigrarCli[i]
  
    let indexSearch1 = -1
    let indexSearchT = -1
    let indexSearchTC = -1
    // console.log(cuentaMigrados)
    // console.log(elemMigrar.estadoCliente)
// console.log(elemMigrar.contrato)
    let tieneDocum = false
    if(cuentaMigrados<47000){
      indexSearch1 = this.props.allClientes1.allClientes.findIndex( cliente => cliente.contrato===elemMigrar.contrato )
      if(indexSearch1!==-1){
        // if(this.props.allClientes1.allClientes[indexSearch1].tarifa.codigoTarifa){
        //   tieneDocum = true
        // }
      }
    }
    // console.log(tieneDocum)
    // console.log(indexSearch1)
    if(cuentaMigrados<47000&&!tieneDocum){
// console.log(cuentaMigrados)
// console.log(elemMigrar.contrato)
      indexSearchTC = elemMigrarsTC.findIndex( cliente => cliente.contrato===elemMigrar.contrato )
      if(indexSearchTC!==-1){
        indexSearchT = elemTarifa.findIndex( tarifa => tarifa.descrTarifa===elemMigrarsTC[indexSearchTC].descrTarifa )
      }
    }
// console.log(indexSearchT)
cuentaMigrados += 1
    if(indexSearch1!==-1&&indexSearchT!==-1&&cuentaMigrados<47000&&!tieneDocum){
        // cuentaMigrados += 1
        // console.log(cuentaMigrados)

        //ACTUALIZAR TARIFA A LOS CLIENTES
      // creaColecc = [], movColecc = []
      let servColecc = []
      let nomRes = 0
      for(let numS=0; numS<3; numS++){
// console.log(nomRes)
        argsAdd = {}
        // argsUpd = {}
        let movColecc = []
        let indexSearch = -1
        if(nomRes===0){
          nomRes = 1
          indexSearch = elemTarifa[indexSearchT].servicios.findIndex( tarifa => tarifa.nombreResumido===elemMigrarsTC[indexSearchTC].nombreResumido1 )
        }else{
          if(nomRes===1){
            nomRes = 2
            indexSearch = elemTarifa[indexSearchT].servicios.findIndex( tarifa => tarifa.nombreResumido===elemMigrarsTC[indexSearchTC].nombreResumido2 )
          }else{
            indexSearch = elemTarifa[indexSearchT].servicios.findIndex( tarifa => tarifa.nombreResumido===elemMigrarsTC[indexSearchTC].nombreResumido3 )
          }
        }
// console.log(indexSearch)
        if(indexSearch!==-1){
          let valorI = 0

          elemTarifa[indexSearchT].servicios[indexSearch].imptos.forEach((elemento1, ii) => {
            if(elemento1.codigoImpto!==null){
              valorI += Math.round(elemTarifa[indexSearchT].servicios[indexSearch].rango1Valor * (elemento1.porcImpto / 100))

              let argsUpd = {}
              // argsUpd['tipoAct'] = ii===0?"CrearImpto1":"CrearImpto2"
              // argsUpd['_id'] = elemMigrar._id
              // argsUpd['contrato'] = elemMigrar.contrato
              // argsUpd['codigoTarifa'] = elemTarifa[indexSearchT].codigoTarifa
              // argsUpd['codigoServicioT'] = elemTarifa[indexSearchT].servicios[indexSearch].codigoServicio
              argsUpd['codigoImpto'] = elemento1.codigoImpto
              argsUpd['descrImpto'] = elemento1.descrImpto
              argsUpd['porcImpto'] = elemento1.porcImpto
              argsUpd['valorImpto'] = valorI

              movColecc.push(argsUpd)
            }
          })
// console.log(movColecc)
          let valorS = parseInt(elemTarifa[indexSearchT].servicios[indexSearch].rango1Valor, 10) + parseInt(valorI, 10)

          // argsAdd['tipoAct'] = i===0?"EditarTarifa":"EditarServTar"
          // argsAdd['_id'] = elemMigrar._id
          // argsAdd['contrato'] = elemMigrar.contrato
          // argsAdd['codigoTarifa'] = elemTarifa[indexSearchT].codigoTarifa
          // argsAdd['descrTarifa'] = elemTarifa[indexSearchT].descrTarifa
          // argsAdd['fechaVence'] = fechaV
          argsAdd['codigoServicio'] = elemTarifa[indexSearchT].servicios[indexSearch].codigoServicio
          argsAdd['nombreResumido'] = elemTarifa[indexSearchT].servicios[indexSearch].nombreResumido
          argsAdd['descripcionServicio'] = elemTarifa[indexSearchT].servicios[indexSearch].descripcionServicio

          argsAdd['subclaseserv'] = {_id: elemTarifa[indexSearchT].servicios[indexSearch].subclaseserv._id,
            codigoSubclaseServ: elemTarifa[indexSearchT].servicios[indexSearch].subclaseserv.codigoSubclaseServ,
            descrSubclaseServ: elemTarifa[indexSearchT].servicios[indexSearch].subclaseserv.descrSubclaseServ,
            claseserv: {_id: elemTarifa[indexSearchT].servicios[indexSearch].subclaseserv.claseserv._id,
              codigoClaseServ: elemTarifa[indexSearchT].servicios[indexSearch].subclaseserv.claseserv.codigoClaseServ,
              descrClaseServ: elemTarifa[indexSearchT].servicios[indexSearch].subclaseserv.claseserv.descrClaseServ
            }}

          argsAdd['estadoServicio'] = "A"

          // argsAdd['_idSubclaseServT'] = elemTarifa[indexSearchT].servicios[indexSearch].subclaseserv._id
          // argsAdd['codigoSubclaseServT'] = elemTarifa[indexSearchT].servicios[indexSearch].subclaseserv.codigoSubclaseServ
          // argsAdd['descrSubclaseServT'] = elemTarifa[indexSearchT].servicios[indexSearch].subclaseserv.descrSubclaseServ
          // argsAdd['_idClaseServT'] = elemTarifa[indexSearchT].servicios[indexSearch].subclaseserv.claseserv._id
          // argsAdd['codigoClaseServT'] = elemTarifa[indexSearchT].servicios[indexSearch].subclaseserv.claseserv.codigoClaseServ
          // argsAdd['descrClaseServT'] = elemTarifa[indexSearchT].servicios[indexSearch].subclaseserv.claseserv.descrClaseServ
          argsAdd['rango1NumServValorIni'] = elemTarifa[indexSearchT].servicios[indexSearch].rango1NumServValorIni
          argsAdd['rango1NumServValorFin'] = elemTarifa[indexSearchT].servicios[indexSearch].rango1NumServValorFin
          argsAdd['rango1Valor'] = elemTarifa[indexSearchT].servicios[indexSearch].rango1Valor
          argsAdd['rango2NumServValorIni'] = elemTarifa[indexSearchT].servicios[indexSearch].rango2NumServValorIni
          argsAdd['rango2NumServValorFin'] = elemTarifa[indexSearchT].servicios[indexSearch].rango2NumServValorFin
          argsAdd['rango2Valor'] = elemTarifa[indexSearchT].servicios[indexSearch].rango2Valor
          argsAdd['rango3NumServValorIni'] = elemTarifa[indexSearchT].servicios[indexSearch].rango3NumServValorIni
          argsAdd['rango3NumServValorFin'] = elemTarifa[indexSearchT].servicios[indexSearch].rango3NumServValorFin
          argsAdd['rango3Valor'] = elemTarifa[indexSearchT].servicios[indexSearch].rango3Valor
          argsAdd['numeroServicios'] = "1"
          argsAdd['valorServicios'] = valorS
          argsAdd['valorAntesImptos'] = parseInt(elemTarifa[indexSearchT].servicios[indexSearch].rango1Valor, 10)
          argsAdd['imptos'] = movColecc

          // creaColecc.push(argsAdd)
          servColecc.push(argsAdd)
// console.log(argsAdd)
        }
      }
      
      argsAdd = {}
      argsAdd['tipoAct'] = "EditarTarifa"
      argsAdd['contrato'] = elemMigrar.contrato
      argsAdd['tarifa'] = {codigoTarifa: elemTarifa[indexSearchT].codigoTarifa,
        descrTarifa: elemTarifa[indexSearchT].descrTarifa,
        fechaVence: fechaV,
        servicios: servColecc}

      creaColecc.push(argsAdd)
    }
  }
  // })

// console.log(creaColecc)

  if(creaColecc.length>0){
    let actCliMany1 = []
// console.log(creaColecc)
  actCliMany1.push({cliente: creaColecc})

  //Actualiza la tarifa de los clientes
  let numDocCRUD = 0
  let totDocCRUD = 1
  let argsCrud = []
  let crudColecc = []
  for(let iii=0; iii<totDocCRUD; iii++){
    argsCrud.push({ctrlCampo: 'NO_CRUD'})
  }
  for(let iii=0; iii<totDocCRUD; iii++){
    crudColecc.push(this.props.editClienteUpdDocMany)
  }
  
  argsCrud[numDocCRUD] = actCliMany1[0]
  argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
  argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
  crudColecc[numDocCRUD] = this.props.editClienteUpdDocMany
  
  console.log(argsCrud)
  console.log(totDocCRUD)
  this.updColecc(crudColecc, argsCrud, totDocCRUD)
}
  console.log("Listooooooo")
}

handleMigMovimCli = async ()=>{
  let args = {}
  const elemMigrars = await this.props.allMigrarMovimCli.allMigrarMovimCli

  let elemMigrarCli = await this.props.allCliTodos.allCliTodos
  elemMigrarCli = await _.orderBy(elemMigrarCli, ['contrato'])

  // let numCli = 0

  console.log(elemMigrars)
  console.log(elemMigrarCli)
  // elemMigrars.forEach(async (elemMigrar, i) => {
    // let numProcIni = 10
    for(let i=0; i<100; i++){
// para equipos
// for(let i=0; i<1; i++){
  // let i = 0
      let elemMigrar = elemMigrars[0]

    let actColecc = []
    args = {}
    let fechaMov = null
    if(elemMigrar.fechaMov.substr(0, 10)!=="01/01/1900"){
      fechaMov = `${elemMigrar.fechaMov.substr(6, 4)}-${elemMigrar.fechaMov.substr(3, 2)}-${elemMigrar.fechaMov.substr(0, 2)}`
    }
    let fechaCreate = null
    if(elemMigrar.fechaCreate.substr(0, 10)!=="01/01/1900"){
      fechaCreate = `${elemMigrar.fechaCreate.substr(6, 4)}-${elemMigrar.fechaCreate.substr(3, 2)}-${elemMigrar.fechaCreate.substr(0, 2)}`
    }

    // args['contrato'] = elemMigrar.contrato
    if(i===0){
      console.log(elemMigrarCli[0].contrato, elemMigrarCli[200].contrato)

      args['contrato'] = elemMigrarCli[0].contrato
      args['tipo'] = elemMigrarCli[200].contrato

      // args['contrato'] = i.toString()
      // args['tipo'] = '10'
    }else{
      if(elemMigrarCli.length < (i*200) + 200){
        args['contrato'] = elemMigrarCli[i*200].contrato
        args['tipo'] = elemMigrarCli[elemMigrarCli.length-1].contrato
  
        i = 101
      }else{
        args['contrato'] = elemMigrarCli[i*200].contrato
        args['tipo'] = elemMigrarCli[(i*200) + 200].contrato
      }


      // args['contrato'] = numProcIni.toString()
      // numProcIni += 2
      // args['tipo'] = numProcIni.toString()
      
      // if(numProcIni===96){
      //   i = 101
      // }
    }





    
    args['fechaMov'] = fechaMov
    // args['tipo'] = elemMigrar.tipo
    args['subTipo'] = elemMigrar.subTipo
    args['procesado'] = elemMigrar.procesado
    args['pagueHasta'] = elemMigrar.pagueHasta
    args['numeroOdeDX'] = elemMigrar.numeroOdeDX
    args['codigoServicio'] = elemMigrar.codigoServicio
    args['nombreResumido'] = elemMigrar.nombreResumido
    args['descripcionServicio'] = elemMigrar.descripcionServicio
    args['descrClaseServ'] = elemMigrar.descrClaseServ
    args['concepto'] = elemMigrar.concepto
    args['periodo'] = elemMigrar.periodo
    args['origen'] = elemMigrar.origen
    args['saldoCliente'] = elemMigrar.saldoCliente
    args['valorTotal'] = elemMigrar.valorTotal
    args['valorAntesImptos'] = elemMigrar.valorAntesImptos
    args['valorPagado'] = elemMigrar.valorPagado
    args['agno'] = elemMigrar.agno
    args['mes'] = elemMigrar.mes
    args['numeroFra'] = elemMigrar.numeroFra
    args['valorPendiente'] = elemMigrar.valorPendiente
    args['documento'] = elemMigrar.documento
    args['fechaCreate'] = fechaCreate
    args['usuarioCreate'] = sessionStorage.getItem('userLogin')
    actColecc.push(args)
  console.log(i, args)

    let actColecc1 = []
    actColecc1.push({movcliente: actColecc})

    let numDocCRUD = 0
    let totDocCRUD = 1
    let argsCrud = []
    let crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      crudColecc.push(this.props.createMovClientesMany)
    }
    
    argsCrud[numDocCRUD] = actColecc1[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    // crudColecc[numDocCRUD] = this.props.createMovClientesMany
    
    // console.log(argsCrud)
    // console.log(totDocCRUD)
    // if(i===0){
      console.log(i, argsCrud)
      await this.updColecc(crudColecc, argsCrud, totDocCRUD)
  //   }
  }
  // })
}

handleMigUpdRM = async ()=>{
  let argsUpd = {}
  // let cuentaMigrados = 0
  let movColecc = [], actColecc = []

  const elemMigrarCli = this.props.allClientes1.allClientes
  var elemMigrars = this.props.allMigrarCliente.allMigrarCliente

  // elemMigrarCli.forEach(async (elemMigrar, i) => {
    for(let i=0; i<elemMigrarCli.length; i++){
      let elemMigrar = elemMigrarCli[i]
  
//ACTUALIZAR RENTA A LOS CLIENTES
    // if(cuentaMigrados<5){

//para hacer proceso masivo de actualizacion de ciclo
    // let indexSearch = elemMigrars.findIndex( cliente => cliente.contrato===elemMigrar.contrato )
    // let cicloFact = ""
    // if(indexSearch!==-1){
    //   if(elemMigrars[indexSearch].cicloFact){
    //     cicloFact = elemMigrars[indexSearch].cicloFact
    //   }else{
    //     console.log(elemMigrars[indexSearch])
    //   }
    // }
//fin para hacer proceso masivo de actualizacion de ciclo

    argsUpd = {}
    let saldoCl = 0
    let rentaAct = 0
    if(elemMigrar.tarifa.codigoTarifa){
      elemMigrar.tarifa.servicios.forEach((elemento, i) => {
        rentaAct += elemento.valorServicios
      })
    }

//calcular el saldo para pagos por adelantado
// console.log(elemMigrar.contrato)
    let indexSearch = elemMigrars.findIndex( cliente => cliente.contrato===elemMigrar.contrato )
    // console.log(indexSearch)
    let saldoAdel = 0
    if(indexSearch!==-1){
      if(elemMigrars[indexSearch].mesesadelantado>0){
        saldoAdel = (elemMigrars[indexSearch].mesesadelantado * rentaAct) * -1
      }
      if(elemMigrars[indexSearch].saldoPendiente!==0){
        saldoCl = elemMigrars[indexSearch].saldoPendiente
      }
    // }

    let saldoPendiente = parseInt(saldoCl, 10) + parseInt(saldoAdel, 10)
    // if(rentaAct!==0&&elemMigrar.cargoMensual===0){
      // cuentaMigrados += 1
      // console.log(cuentaMigrados)

      argsUpd = {
        "tipoAct": "EditarCliOdeS",
        "_id": elemMigrar._id,
        "estadoCliente": elemMigrar.estadoCliente,
        "cargoMensual": rentaAct,
        "saldoPendiente": saldoPendiente,
        // "cicloFact": cicloFact,
      }
      movColecc.push(argsUpd)
      console.log(argsUpd)

//OJOOOO no va movim porque queda con saldo
//si tiene pago adelantado => se crea movcliente => OJOOOO solo una vez, si se corre el proceso mas de
//una vez => comentar el proceso de la segunda ejecucion en adelante
// console.log(elemMigrars[indexSearch])
if(elemMigrars[indexSearch].mesesadelantado>0){
  console.log(saldoAdel)
  console.log(elemMigrars[indexSearch].mesesadelantado)
  let argsMovTV = {}
  // actColecc = []
    let fechaHoy = new Date()
    // let agnoHoy = fechaHoy.getFullYear()
    // let mesHoy = ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1))
    fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())

    argsMovTV['contrato'] = elemMigrars[indexSearch].contrato
    argsMovTV['fechaMov'] = fechaHoy
    argsMovTV['tipo'] = "D"
    argsMovTV['subTipo'] = "PA"
    argsMovTV['procesado'] = "S"
    argsMovTV['pagueHasta'] = fechaHoy

    argsMovTV['codigoServicio'] = "PADEL"
    argsMovTV['nombreResumido'] = "Pago adelantado"
    argsMovTV['descripcionServicio'] = "Pago adelantado"
    argsMovTV['descrClaseServ'] = "Television"
    argsMovTV['concepto'] = "Pago adelantado"

    argsMovTV['periodo'] = elemMigrars[indexSearch].mesesadelantado + "meses"
    argsMovTV['origen'] = "Pago adelantado"
    argsMovTV['saldoCliente'] = saldoPendiente
    argsMovTV['valorTotal'] = saldoAdel * -1
    argsMovTV['valorAntesImptos'] = saldoAdel * -1
    argsMovTV['valorPagado'] = saldoAdel * -1
    // argsMovTV['agno'] = agnoHoy
    // argsMovTV['mes'] = mesHoy
    argsMovTV['numeroFra'] = 'INICIAL'
    argsMovTV['usuarioCreate'] = sessionStorage.getItem('userLogin')
    actColecc.push(argsMovTV)
console.log(argsMovTV)



}
    }
  }
  // })

console.log(movColecc, actColecc)
  if(movColecc.length>0){
    let actCliMany1 = []
    actCliMany1.push({cliente: movColecc})

    let actColecc1 = []
    if(actColecc.length>0){
      console.log(movColecc, actColecc)
      actColecc1.push({movcliente: actColecc})
    }
  
  //Actualiza la dir de los clientes
  let numDocCRUD = 0
  let totDocCRUD = 2
  if(actColecc1.length===0){
    totDocCRUD = 1
  }
  let argsCrud = []
  let crudColecc = []
  for(let iii=0; iii<totDocCRUD; iii++){
    argsCrud.push({ctrlCampo: 'NO_CRUD'})
  }
  for(let iii=0; iii<totDocCRUD; iii++){
    crudColecc.push(this.props.editClienteMany)
  }

  if(actColecc1.length>0){
    argsCrud[numDocCRUD] = actColecc1[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.createMovClientesMany
  
    numDocCRUD += 1
  } 
  argsCrud[numDocCRUD] = actCliMany1[0]
  argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
  argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
  crudColecc[numDocCRUD] = this.props.editClienteMany
  
  console.log(argsCrud)
  console.log(totDocCRUD)
  this.updColecc(crudColecc, argsCrud, totDocCRUD)
}  

// //para procesar los pendientes
//   if(movColecc.length>0){
//     let numDocCRUD = 0
//     let totDocCRUD = movColecc.length
//     let argsCrud = []
//     let crudColecc = []
//     for(let iii=0; iii<totDocCRUD; iii++){
//       argsCrud.push({ctrlCampo: 'NO_CRUD'})
//     }
//     for(let iii=0; iii<totDocCRUD; iii++){
//       crudColecc.push(this.props.editCliente)
//     }

//     movColecc.forEach((elemento1, ii) => {
//       argsCrud[numDocCRUD] = elemento1
//       argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
//       argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

//       numDocCRUD += 1
//     })
// console.log(argsCrud)
//     this.updColecc(crudColecc, argsCrud, totDocCRUD)
//   }

  console.log("Listooooooo")
}

handleMigEquipo = async ()=>{
  
}

//FIN MIGRACION

  render(){
    const {showMigrar} = this.state;        

    return (
      <div>
        <div className="ui two column stackable grid">
          <div className="column" style={this.props.styles.boxIzq}>
            {showMigrar && <HomeMigrar1 styles={this.props.styles} handleClickMigBarr={this.handleMigBarr}
                              handleClickMigServ={this.handleMigServ} handleClickMigTar={this.handleMigTar}
                              handleClickMigCli={this.handleMigCli} handleClickMigDir={this.handleMigDir}
                              handleClickMigTarCli={this.handleMigTarCli} handleClickMigMovCli={this.handleMigMovimCli}
                              handleClickMigUpdRM={this.handleMigUpdRM} handleClickMigEquipo={this.handleMigEquipo}/>}
          </div>
          <div className="column" style={this.props.styles.boxDer}>
            {showMigrar && <HomeMigrar2 styles={this.props.styles}/>}
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allCliTodos, {name:'allCliTodos'}),

  graphql(queries.mutation.createCliente, {name:'createCliente'}),
  graphql(queries.mutation.editCliente, {name:'editCliente'}),
  graphql(queries.mutation.editClienteUpdDoc, {name:'editClienteUpdDoc'}),
  graphql(queries.mutation.createMovClientes, {name:'createMovClientes'}),
  graphql(queries.query.allTiposCliente, {name:'allTiposCliente'}),
  graphql(queries.query.allGruposAfin, {name:'allGruposAfin'}),
  graphql(queries.query.allTiposDoc, {name:'allTiposDoc'}),
  graphql(queries.mutation.createServicio, {name:'createServicio'}),

  graphql(queries.mutation.createClienteMany, {name:'createClienteMany'}),
  graphql(queries.mutation.createMovClientesMany, {name:'createMovClientesMany'}),
  graphql(queries.mutation.editClienteMany, {name:'editClienteMany'}),
  graphql(queries.mutation.editClienteUpdDocMany, {name:'editClienteUpdDocMany'}),

  graphql(queries.query.allMigrarBarrio, {name:'allMigrarBarrio'}),
  graphql(queries.mutation.editDptoUpdCiu, {name:'editDptoUpdCiu'}),
  graphql(queries.query.allDirmayor, {name:'allDirmayor', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allMigrarServicio, {name:'allMigrarServicio'}),
  graphql(queries.query.allSubclasesServ, {name:'allSubclasesServ', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allMigrarTarifa, {name:'allMigrarTarifa'}),
  graphql(queries.query.allServicios, {name:'allServicios', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.editTarifaUpdServ, {name:'editTarifaUpdServ'}),
  graphql(queries.query.allMigrarCliente, {name:'allMigrarCliente'}),
  graphql(queries.query.allMigrarDireccion, {name:'allMigrarDireccion'}),
  graphql(queries.query.allMigrarDirmayor, {name:'allMigrarDirmayor'}),
  graphql(queries.query.allMigrarTarifaCli, {name:'allMigrarTarifaCli'}),
  graphql(queries.query.allMigrarMovimCli, {name:'allMigrarMovimCli'}),
  
  graphql(queries.query.allTarifa, {name:'allTarifa', options: (props) => {return {variables: {}}}}),
  // graphql(queries.query.allClientes, {name:'allClientes1', options: (props) => {return {variables: {}}}}),

  graphql(queries.query.allMovRtes, {name:'allMovRtes', options: (props) => {return {variables: argsBuscarMCNeg}}}),
  graphql(queries.mutation.editMovClientesMany, {name:'editMovClientesMany'}),

//Se pone numDocum de 2027 porque si se deja sin el limite en la ventana de mongo sale el mensaje:
//MongoError: Executor error during find command :: caused by :: Sort operation used more than the
//maximum 33554432 bytes of RAM. Add an index, or specify a smaller limit.
  graphql(queries.query.allClientes, {name:'allClientes1', options: (props) => {return {variables: {numDocum: 2027}}}}),
)(HomeMigrar)
